<su-headline h="h1" skin="primary">{{ headline }}</su-headline>

<div class="frozenZoneDescriptionContainer" *ngIf="frozenStatus">
  <div
    class="sub-headline contactDescription"
    class="frozenZoneDescription"
    [innerHtml]="description | safeHtml"></div>
</div>

<su-headline h="h2" skin="tertiary"
  >{{ 'locationServices.currentRoom' | translate
  }}{{ currentRoom }}</su-headline
>
<su-headline h="h2" skin="default">
  {{ 'locationServices.numberOfWorkingPlaces' | translate }}
  <mat-form-field class="custom-input">
    <input
      matInput
      type="number"
      [(ngModel)]="numberOfWorkingPlaces"
      placeholder="Enter number of working places"
      [disabled]="frozenStatus"
      [min]="1" />
  </mat-form-field>
</su-headline>

<su-button
  [label]="'locationServices.addWorkingSpaceButton' | translate"
  skin="primary"
  (onClick)="addWorkingSpace()"
  [disabled]="frozenStatus || loadingData">
</su-button>

<su-slot-tab-content>
  <mtx-grid
    [columns]="columns"
    [data]="workingSpaceList$ | async"
    [loading]="loadingData"
    [columnSortable]="true"
    [columnResizable]="config.grid.columnResizable"
    [columnPinnable]="false"
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    [pageSize]="config.grid.paging.pageSize"
    [pageIndex]="config.grid.paging.pageIndex"
    [showPaginator]="config.grid.paging.showPaginator"
    [rowStriped]="true"
    [cellSelectable]="false"
    class="table-width">
  </mtx-grid>
  <ng-template #checkboxInactiveTemplate let-row>
    <mat-checkbox
      [(ngModel)]="row.isActive"
      [disabled]="frozenStatus"></mat-checkbox>
  </ng-template>
  <ng-template #checkboxDummyTemplate let-row>
    <mat-checkbox
      [disabled]="!row.isActive || frozenStatus"
      [(ngModel)]="row.isDummy"
      (change)="onCheckboxClick($event, row.subSpaceId)"></mat-checkbox>
  </ng-template>
  <ng-template #inputAPNoTemplate let-row>
    <span style="color: gray; font-size: larger">
      {{ row.apNo }}
    </span>
  </ng-template>
  <ng-template #inputNameTemplate let-row>
    <mat-form-field>
      <input
        [disabled]="!row.isActive || frozenStatus"
        matInput
        [(ngModel)]="row.name"
        type="text" />
    </mat-form-field>
  </ng-template>
  <ng-template #selectDummyKindTemplate let-row>
    <mat-form-field>
      <mat-select
        [disabled]="!row.isActive || frozenStatus || !row.isDummy"
        class="select"
        [(value)]="row.dummyKind"
        [placeholder]="'shared.select' | translate">
        <mat-option
          *ngFor="let dummyType of dummyTypes"
          [value]="$any(dummyType).id"
          [title]="$any(dummyType).name"
          [matTooltip]="$any(dummyType).name">
          {{ $any(dummyType).name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>
  <ng-template #selectAreaTypeTemplate let-row>
    <mat-form-field>
      <mat-select
        [disabled]="frozenStatus"
        class="select"
        [(value)]="row.magentaSpaceType"
        [placeholder]="'shared.select' | translate">
        <mat-option
          *ngFor="let officeAreaType of officeAreaTypes"
          [value]="$any(officeAreaType).id"
          [title]="$any(officeAreaType).name"
          [matTooltip]="$any(officeAreaType).name">
          {{ $any(officeAreaType).name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>

  <div
    style="display: flex; gap: 20px; flex-direction: column; margin-top: 10px">
    <div style="width: 50%">
      <mat-form-field class="wrapper-full">
        <mat-label>{{ 'locationServices.changeReason' | translate }}</mat-label>
        <input
          matInput
          type="text"
          [formControl]="changeReasonSearchControl"
          [matAutocomplete]="changeReasonAuto"
          [placeholder]="'shared.select' | translate"
          [disabled]="frozenStatus"
          required />
        <mat-icon matSuffix>arrow_drop_down</mat-icon>
        <mat-autocomplete
          autoActiveFirstOption
          #changeReasonAuto="matAutocomplete"
          [displayWith]="displayChangeReasonFn.bind(this)">
          <mat-option
            *ngFor="let changeReason of filteredChangeReasons | async"
            [value]="changeReason.id">
            {{ changeReason.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="handlingPanel">
      <su-button
        skin="secondary"
        [label]="'shared.cancel' | translate"
        (onClick)="onCancelClick()"
        [disabled]="frozenStatus"></su-button>
      <su-button
        skin="primary"
        [label]="'shared.save' | translate"
        (onClick)="save()"
        [disabled]="
          !changeReasonSearchControl.value || frozenStatus
        "></su-button>
    </div>
  </div>
</su-slot-tab-content>

<app-spinner-overlay [show]="isLoading"></app-spinner-overlay>
